/**
 * Web has no lock screen to keep alive; the carrier is skipped entirely so the
 * browser never plays a looping silent track.
 */
export function getSilenceCarrierAudioSource(): number | null {
  return null;
}
